// shrinkImage verkleinert ein Foto im Browser vor dem Hochladen (lange Kante höchstens maxSize, JPEG). Grundrisse
// als PNG bleiben PNG (Linien bleiben scharf). Klappt das nicht (z. B. altes Format), wird die Datei unverändert
// hochgeladen – der Server prüft ohnehin Typ und Größe.
export async function shrinkImage(file: File, maxSize: number, keepPng = false): Promise<Blob> {
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxSize / Math.max(bitmap.width, bitmap.height));
    const png = keepPng && file.type === 'image/png';
    if (scale === 1 && (file.type === 'image/jpeg' || png) && file.size < 3 * 1024 * 1024) return file;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const ctx = canvas.getContext('2d');
    if (!ctx) return file;
    if (!png) {
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, png ? 'image/png' : 'image/jpeg', 0.86));
    return blob ?? file;
  } catch {
    return file;
  }
}
